/* OnboardingStage — the shared full-screen Sofi backdrop used by all three
   onboarding flows (new-user, add-account, AI-setup). */
import { POSE, Pose, Icon } from './onboardingKit';
import './onboarding.css';

function Sofi({ pose }: { pose: Pose }) {
  return (
    <div className="sofi-wrap" aria-hidden="true">
      <div className="sofi-glow" />
      <div className="sofi-float">
        {(Object.keys(POSE) as Pose[]).map((k) => (
          <img key={k} src={POSE[k]} alt="" draggable={false} className={'sofi-img' + (k === pose ? ' on' : '')} />
        ))}
      </div>
    </div>
  );
}

export function OnboardingStage({ pose, onClose, children }: {
  pose: Pose;
  onClose?: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="om-stage">
      <img className="om-bg" src="/onboarding/dashboard.webp" alt="" />
      <div className="om-dim" />
      <div className="om-cornerglow" />
      <Sofi pose={pose} />
      {onClose && (
        <button className="om-close" onClick={onClose} aria-label="Close" title="Close">
          <span style={{ display: 'inline-flex', transform: 'rotate(45deg)' }}><Icon name="plus" size={20} /></span>
        </button>
      )}
      <div className="om-content">{children}</div>
    </div>
  );
}
